import { gql } from '@apollo/client';
export const createComplaintVisitor = gql `
  mutation CreateComplaintVisitor(
    $input: CreateComplaintVisitorInput!
    $condition: ModelComplaintVisitorConditionInput
  ) {
    createComplaintVisitor(input: $input, condition: $condition) {
      id
      name
      page
      sitename
      city
      countryName
      countryCode
      postal
      latitude
      longitude
      ip
      stateName
      createdAt
      updatedAt
    }
  }
`;
export const updateComplaintVisitor = gql `
  mutation UpdateComplaintVisitor(
    $input: UpdateComplaintVisitorInput!
    $condition: ModelComplaintVisitorConditionInput
  ) {
    updateComplaintVisitor(input: $input, condition: $condition) {
      id
      name
      page
      sitename
      city
      countryName
      countryCode
      postal
      latitude
      longitude
      ip
      stateName
      createdAt
      updatedAt
    }
  }
`;
export const deleteComplaintVisitor = gql `
  mutation DeleteComplaintVisitor(
    $input: DeleteComplaintVisitorInput!
    $condition: ModelComplaintVisitorConditionInput
  ) {
    deleteComplaintVisitor(input: $input, condition: $condition) {
      id
      name
      page
      sitename
      city
      countryName
      countryCode
      postal
      latitude
      longitude
      ip
      stateName
      createdAt
      updatedAt
    }
  }
`;
export const createComplaintHistoryAction = gql `
  mutation CreateComplaintHistoryAction(
    $input: CreateComplaintHistoryActionInput!
    $condition: ModelComplaintHistoryActionConditionInput
  ) {
    createComplaintHistoryAction(input: $input, condition: $condition) {
      id
      cognitoId
      name
      email
      page
      actionType
      actionDescription
      actionError
      note
      createdAt
      updatedAt
    }
  }
`;
export const updateComplaintHistoryAction = gql `
  mutation UpdateComplaintHistoryAction(
    $input: UpdateComplaintHistoryActionInput!
    $condition: ModelComplaintHistoryActionConditionInput
  ) {
    updateComplaintHistoryAction(input: $input, condition: $condition) {
      id
      cognitoId
      name
      email
      page
      actionType
      actionDescription
      actionError
      note
      createdAt
      updatedAt
    }
  }
`;
export const deleteComplaintHistoryAction = gql `
  mutation DeleteComplaintHistoryAction(
    $input: DeleteComplaintHistoryActionInput!
    $condition: ModelComplaintHistoryActionConditionInput
  ) {
    deleteComplaintHistoryAction(input: $input, condition: $condition) {
      id
      cognitoId
      name
      email
      page
      actionType
      actionDescription
      actionError
      note
      createdAt
      updatedAt
    }
  }
`;
export const createComplaintUser = gql `
  mutation CreateComplaintUser(
    $input: CreateComplaintUserInput!
    $condition: ModelComplaintUserConditionInput
  ) {
    createComplaintUser(input: $input, condition: $condition) {
      cognitoId
      name
      email
      userType
      createdAt
      conformites {
        items {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        nextToken
      }
      complaints {
        items {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updateComplaintUser = gql `
  mutation UpdateComplaintUser(
    $input: UpdateComplaintUserInput!
    $condition: ModelComplaintUserConditionInput
  ) {
    updateComplaintUser(input: $input, condition: $condition) {
      cognitoId
      name
      email
      userType
      createdAt
      conformites {
        items {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        nextToken
      }
      complaints {
        items {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deleteComplaintUser = gql `
  mutation DeleteComplaintUser(
    $input: DeleteComplaintUserInput!
    $condition: ModelComplaintUserConditionInput
  ) {
    deleteComplaintUser(input: $input, condition: $condition) {
      cognitoId
      name
      email
      userType
      createdAt
      conformites {
        items {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        nextToken
      }
      complaints {
        items {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createComplaint = gql `
  mutation CreateComplaint(
    $input: CreateComplaintInput!
    $condition: ModelComplaintConditionInput
  ) {
    createComplaint(input: $input, condition: $condition) {
      confirmation
      cognitoId
      statut
      object
      firstname
      lastname
      email
      phone
      company
      complaintType
      description
      createdAt
      modeSoumission
      responsable
      filename
      userComplaint {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      complaintNotes {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintNotesId
        }
        nextToken
      }
      complaintCpgs {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintCpgsId
        }
        nextToken
      }
      updatedAt
      complaintUserComplaintsId
    }
  }
`;
export const updateComplaint = gql `
  mutation UpdateComplaint(
    $input: UpdateComplaintInput!
    $condition: ModelComplaintConditionInput
  ) {
    updateComplaint(input: $input, condition: $condition) {
      confirmation
      cognitoId
      statut
      object
      firstname
      lastname
      email
      phone
      company
      complaintType
      description
      createdAt
      modeSoumission
      responsable
      filename
      userComplaint {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      complaintNotes {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintNotesId
        }
        nextToken
      }
      complaintCpgs {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintCpgsId
        }
        nextToken
      }
      updatedAt
      complaintUserComplaintsId
    }
  }
`;
export const deleteComplaint = gql `
  mutation DeleteComplaint(
    $input: DeleteComplaintInput!
    $condition: ModelComplaintConditionInput
  ) {
    deleteComplaint(input: $input, condition: $condition) {
      confirmation
      cognitoId
      statut
      object
      firstname
      lastname
      email
      phone
      company
      complaintType
      description
      createdAt
      modeSoumission
      responsable
      filename
      userComplaint {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      complaintNotes {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintNotesId
        }
        nextToken
      }
      complaintCpgs {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintCpgsId
        }
        nextToken
      }
      updatedAt
      complaintUserComplaintsId
    }
  }
`;
export const createComplaintNote = gql `
  mutation CreateComplaintNote(
    $input: CreateComplaintNoteInput!
    $condition: ModelComplaintNoteConditionInput
  ) {
    createComplaintNote(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintNotesId
    }
  }
`;
export const updateComplaintNote = gql `
  mutation UpdateComplaintNote(
    $input: UpdateComplaintNoteInput!
    $condition: ModelComplaintNoteConditionInput
  ) {
    updateComplaintNote(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintNotesId
    }
  }
`;
export const deleteComplaintNote = gql `
  mutation DeleteComplaintNote(
    $input: DeleteComplaintNoteInput!
    $condition: ModelComplaintNoteConditionInput
  ) {
    deleteComplaintNote(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintNotesId
    }
  }
`;
export const createComplaintCpg = gql `
  mutation CreateComplaintCpg(
    $input: CreateComplaintCpgInput!
    $condition: ModelComplaintCpgConditionInput
  ) {
    createComplaintCpg(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintCpgsId
    }
  }
`;
export const updateComplaintCpg = gql `
  mutation UpdateComplaintCpg(
    $input: UpdateComplaintCpgInput!
    $condition: ModelComplaintCpgConditionInput
  ) {
    updateComplaintCpg(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintCpgsId
    }
  }
`;
export const deleteComplaintCpg = gql `
  mutation DeleteComplaintCpg(
    $input: DeleteComplaintCpgInput!
    $condition: ModelComplaintCpgConditionInput
  ) {
    deleteComplaintCpg(input: $input, condition: $condition) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintCpgsId
    }
  }
`;
export const createConformite = gql `
  mutation CreateConformite(
    $input: CreateConformiteInput!
    $condition: ModelConformiteConditionInput
  ) {
    createConformite(input: $input, condition: $condition) {
      numeroFiche
      cognitoId
      emetteur
      dateDetection
      responsableProcessus
      descriptionConstat
      actionImemdiate
      dateAction
      responsableVisa
      responsableRQA
      dateRQA
      constatControle
      dateConstat
      constatEfficacite
      tauxEfficacite
      decisionSuivi
      actionCloture
      visaTraitement
      visaSuivi
      createdAt
      user {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      actions {
        items {
          id
          name
          conformiteId
          description
          createdAt
          updatedAt
          conformiteActionsId
        }
        nextToken
      }
      problems {
        items {
          id
          conformiteId
          name
          description
          createdAt
          updatedAt
          conformiteProblemsId
        }
        nextToken
      }
      correctives {
        items {
          id
          conformiteId
          description
          responsableSuivi
          responsableTraitement
          datePrevue
          createdAt
          updatedAt
          conformiteCorrectivesId
        }
        nextToken
      }
      updatedAt
      complaintUserConformitesId
    }
  }
`;
export const updateConformite = gql `
  mutation UpdateConformite(
    $input: UpdateConformiteInput!
    $condition: ModelConformiteConditionInput
  ) {
    updateConformite(input: $input, condition: $condition) {
      numeroFiche
      cognitoId
      emetteur
      dateDetection
      responsableProcessus
      descriptionConstat
      actionImemdiate
      dateAction
      responsableVisa
      responsableRQA
      dateRQA
      constatControle
      dateConstat
      constatEfficacite
      tauxEfficacite
      decisionSuivi
      actionCloture
      visaTraitement
      visaSuivi
      createdAt
      user {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      actions {
        items {
          id
          name
          conformiteId
          description
          createdAt
          updatedAt
          conformiteActionsId
        }
        nextToken
      }
      problems {
        items {
          id
          conformiteId
          name
          description
          createdAt
          updatedAt
          conformiteProblemsId
        }
        nextToken
      }
      correctives {
        items {
          id
          conformiteId
          description
          responsableSuivi
          responsableTraitement
          datePrevue
          createdAt
          updatedAt
          conformiteCorrectivesId
        }
        nextToken
      }
      updatedAt
      complaintUserConformitesId
    }
  }
`;
export const deleteConformite = gql `
  mutation DeleteConformite(
    $input: DeleteConformiteInput!
    $condition: ModelConformiteConditionInput
  ) {
    deleteConformite(input: $input, condition: $condition) {
      numeroFiche
      cognitoId
      emetteur
      dateDetection
      responsableProcessus
      descriptionConstat
      actionImemdiate
      dateAction
      responsableVisa
      responsableRQA
      dateRQA
      constatControle
      dateConstat
      constatEfficacite
      tauxEfficacite
      decisionSuivi
      actionCloture
      visaTraitement
      visaSuivi
      createdAt
      user {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      actions {
        items {
          id
          name
          conformiteId
          description
          createdAt
          updatedAt
          conformiteActionsId
        }
        nextToken
      }
      problems {
        items {
          id
          conformiteId
          name
          description
          createdAt
          updatedAt
          conformiteProblemsId
        }
        nextToken
      }
      correctives {
        items {
          id
          conformiteId
          description
          responsableSuivi
          responsableTraitement
          datePrevue
          createdAt
          updatedAt
          conformiteCorrectivesId
        }
        nextToken
      }
      updatedAt
      complaintUserConformitesId
    }
  }
`;
export const createConformiteAction = gql `
  mutation CreateConformiteAction(
    $input: CreateConformiteActionInput!
    $condition: ModelConformiteActionConditionInput
  ) {
    createConformiteAction(input: $input, condition: $condition) {
      id
      name
      conformiteId
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteActionsId
    }
  }
`;
export const updateConformiteAction = gql `
  mutation UpdateConformiteAction(
    $input: UpdateConformiteActionInput!
    $condition: ModelConformiteActionConditionInput
  ) {
    updateConformiteAction(input: $input, condition: $condition) {
      id
      name
      conformiteId
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteActionsId
    }
  }
`;
export const deleteConformiteAction = gql `
  mutation DeleteConformiteAction(
    $input: DeleteConformiteActionInput!
    $condition: ModelConformiteActionConditionInput
  ) {
    deleteConformiteAction(input: $input, condition: $condition) {
      id
      name
      conformiteId
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteActionsId
    }
  }
`;
export const createConformiteProbleme = gql `
  mutation CreateConformiteProbleme(
    $input: CreateConformiteProblemeInput!
    $condition: ModelConformiteProblemeConditionInput
  ) {
    createConformiteProbleme(input: $input, condition: $condition) {
      id
      conformiteId
      name
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteProblemsId
    }
  }
`;
export const updateConformiteProbleme = gql `
  mutation UpdateConformiteProbleme(
    $input: UpdateConformiteProblemeInput!
    $condition: ModelConformiteProblemeConditionInput
  ) {
    updateConformiteProbleme(input: $input, condition: $condition) {
      id
      conformiteId
      name
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteProblemsId
    }
  }
`;
export const deleteConformiteProbleme = gql `
  mutation DeleteConformiteProbleme(
    $input: DeleteConformiteProblemeInput!
    $condition: ModelConformiteProblemeConditionInput
  ) {
    deleteConformiteProbleme(input: $input, condition: $condition) {
      id
      conformiteId
      name
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteProblemsId
    }
  }
`;
export const createConformiteCorrective = gql `
  mutation CreateConformiteCorrective(
    $input: CreateConformiteCorrectiveInput!
    $condition: ModelConformiteCorrectiveConditionInput
  ) {
    createConformiteCorrective(input: $input, condition: $condition) {
      id
      conformiteId
      description
      responsableSuivi
      responsableTraitement
      datePrevue
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteCorrectivesId
    }
  }
`;
export const updateConformiteCorrective = gql `
  mutation UpdateConformiteCorrective(
    $input: UpdateConformiteCorrectiveInput!
    $condition: ModelConformiteCorrectiveConditionInput
  ) {
    updateConformiteCorrective(input: $input, condition: $condition) {
      id
      conformiteId
      description
      responsableSuivi
      responsableTraitement
      datePrevue
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteCorrectivesId
    }
  }
`;
export const deleteConformiteCorrective = gql `
  mutation DeleteConformiteCorrective(
    $input: DeleteConformiteCorrectiveInput!
    $condition: ModelConformiteCorrectiveConditionInput
  ) {
    deleteConformiteCorrective(input: $input, condition: $condition) {
      id
      conformiteId
      description
      responsableSuivi
      responsableTraitement
      datePrevue
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteCorrectivesId
    }
  }
`;
